import Switch from './switch';

export { type SwitchProps } from './switch';

export default Switch;
